// The U-buckets offered as selectable chips in the create/edit metadata block. A template already
// carrying a bucket outside this list keeps it — the modals union its stored buckets with these.
export const KNOWN_AGE_GROUP_BUCKETS = ['U7', 'U9', 'U11', 'U13', 'U15', 'U18'];
